export default __webpack_public_path__ + "static/media/profile_medium.e37a26a2.svg";